import {
  FDHeadlineText,
  FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { RichTextDisplay } from 'Packages/FacetDesign/Components';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';

const useStyles = makeStyles(() => ({
  descriptionText: {
    fontSize: '18px',
    textAlign: 'left',
  },
}));


export const OverviewSectionInfo = ({ resource }) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} spacing={1}>
      <FDHeadlineText color={'textSecondary'} value={resource.attr('title')} size={'lg'} align={isMobile ? 'center' : 'start'} />
      <RichTextDisplay value={resource.attr('description')} className={classes.descriptionText} />
    </FDStack>
  );
};

OverviewSectionInfo.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
